// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Outlet } from 'react-router-dom';
import Loading from '../../components/Loading';
import { useCollateralEntries } from '../../hooks/other/useCollateralEntries';
import { useCollateralUserService } from '../../hooks/queries/collateral/onboarding/useUserService';
import { CommonUtilitiesLayout } from '../../layout/CommonUtilitiesLayout';

const Collateral: React.FC = () => {
  const userService = useCollateralUserService();

  const entries = useCollateralEntries();
  const { isLoading } = userService;
  if (isLoading) return <Loading />;

  return (
    <CommonUtilitiesLayout entries={entries}>
      <Outlet />
    </CommonUtilitiesLayout>
  );
};

export default Collateral;
